import React from 'react';
import PropTypes from 'prop-types';

export const IconProviders = ({ className, onClick }) => (
  <svg onClick={onClick} className={className} width="44" height="40" viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="44" height="40" rx="20" fill="white" fillOpacity="0.1" />
    <g clipPath="url(#icon-providers-6)">
      <path d="M15.125 29.091C14.8848 29.091 14.6544 29.0416 14.4846 28.9536C14.3147 28.8656 14.2193 28.7463 14.2193 28.6219V11.3783C14.2193 11.2539 14.3147 11.1345 14.4846 11.0466C14.6544 10.9586 14.8848 10.9092 15.125 10.9092C15.3652 10.9092 15.5955 10.9586 15.7654 11.0466C15.9352 11.1345 16.0306 11.2539 16.0306 11.3783V28.6219C16.0306 28.7463 15.9352 28.8656 15.7654 28.9536C15.5955 29.0416 15.3652 29.091 15.125 29.091Z" fill="url(#icon-providers-0)" />
      <path opacity="0.75" d="M16.9583 13.6355H13.2917C12.4318 13.6355 11.7333 14.3364 11.7333 15.2028V16.2019C11.7333 17.0673 12.43 17.7691 13.2908 17.7691H16.9574C17.8173 17.7691 18.5139 17.0673 18.5139 16.2019V15.2019C18.5148 14.3382 17.8182 13.6364 16.9583 13.6364V13.6355Z" fill="url(#icon-providers-1)" />
      <path d="M22.4584 29.091C22.2163 29.091 21.9841 29.0416 21.8129 28.9536C21.6417 28.8656 21.5455 28.7463 21.5455 28.6219V11.3783C21.5455 11.2539 21.6417 11.1345 21.8129 11.0466C21.9841 10.9586 22.2163 10.9092 22.4584 10.9092C22.7005 10.9092 22.9326 10.9586 23.1038 11.0466C23.275 11.1345 23.3712 11.2539 23.3712 11.3783V28.6219C23.3712 28.7463 23.275 28.8656 23.1038 28.9536C22.9326 29.0416 22.7005 29.091 22.4584 29.091Z" fill="url(#con-providers-2)" />
      <path d="M29.7917 29.091C29.5477 29.091 29.3137 29.0416 29.1412 28.9536C28.9686 28.8656 28.8717 28.7463 28.8717 28.6219V11.3783C28.8717 11.2539 28.9686 11.1345 29.1412 11.0466C29.3137 10.9586 29.5477 10.9092 29.7917 10.9092C30.0357 10.9092 30.2697 10.9586 30.4422 11.0466C30.6147 11.1345 30.7117 11.2539 30.7117 11.3783V28.6219C30.7117 28.7463 30.6147 28.8656 30.4422 28.9536C30.2697 29.0416 30.0357 29.091 29.7917 29.091Z" fill="url(#con-providers-3)" />
      <path opacity="0.6" d="M31.4582 13.6365H27.9583C27.1068 13.6365 26.4165 14.3383 26.4165 15.2037V16.2037C26.4165 17.0683 27.1068 17.7701 27.9583 17.7701H31.4582C32.3098 17.7701 33 17.0683 33 16.2028V15.2028C33 14.3392 32.3098 13.6365 31.4582 13.6365Z" fill="url(#con-providers-4)" />
      <path opacity="0.75" d="M24.2917 21.8181H20.625C19.7523 21.8181 19.0447 22.5199 19.0447 23.3854V24.3854C19.0447 25.2499 19.7523 25.9518 20.625 25.9518H24.2917C25.1643 25.9518 25.872 25.2499 25.872 24.3845V23.3845C25.872 22.5199 25.1643 21.8181 24.2917 21.8181Z" fill="url(#con-providers-5)" />
    </g>
    <defs>
      <linearGradient id="icon-providers-0" x1="15.125" y1="10.9092" x2="15.125" y2="29.091" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4EFFC3" />
        <stop offset="1" stopColor="#25CE76" />
      </linearGradient>
      <linearGradient id="icon-providers-1" x1="15.1236" y1="13.6355" x2="15.1236" y2="17.7691" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4EFFC3" />
        <stop offset="1" stopColor="#25CE76" />
      </linearGradient>
      <linearGradient id="con-providers-2" x1="22.4584" y1="10.9092" x2="22.4584" y2="29.091" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4EFFC3" />
        <stop offset="1" stopColor="#25CE76" />
      </linearGradient>
      <linearGradient id="con-providers-3" x1="29.7917" y1="10.9092" x2="29.7917" y2="29.091" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4EFFC3" />
        <stop offset="1" stopColor="#25CE76" />
      </linearGradient>
      <linearGradient id="con-providers-4" x1="29.7083" y1="13.6365" x2="29.7083" y2="17.7701" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4EFFC3" />
        <stop offset="1" stopColor="#25CE76" />
      </linearGradient>
      <linearGradient id="con-providers-5" x1="22.4583" y1="21.8181" x2="22.4583" y2="25.9518" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4EFFC3" />
        <stop offset="1" stopColor="#25CE76" />
      </linearGradient>
      <clipPath id="icon-providers-6">
        <rect width="22" height="20" fill="white" transform="translate(11 10)" />
      </clipPath>
    </defs>
  </svg>
);

IconProviders.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

IconProviders.defaultProps = {
  className: null,
  onClick: () => {}
};
